import * as DatasetHelper from '../dataset-helper';

/**
 * Utility method to determine if the value is a scalar or a property. A property value must be
 * encapsulated by '${}'
 */
function isProperty(value) {
  return value && (typeof value === 'string') && value.startsWith('${') && value.endsWith('}');
}

/**
 * Utility method to return the property name from the value.
 */
function getProperty(value) {
  return value.substring(2, value.length - 1);
}

/**
 * Perform {@code Minus} based on the configuration.
 */
export default function calculate(statistics, dataset, categoryFieldId, calculationStepDefn) {

  if (calculationStepDefn.result.startsWith('category.')) {

    // Category-level calculation.

    const categoryField = DatasetHelper.findField(dataset, categoryFieldId);
    const categories = categoryField.categories;
    const numOfCategories = categories.length;
    categories.forEach(category => {
      const categoryResult = statistics[category.value];
      if (!categoryResult) {
        throw new Error(`Unable to find category results for \"${category.value}\"`);
      }

      // Identify the left value.
      let leftValue = undefined;
      const leftDefn = calculationStepDefn.left;
      if (isProperty(leftDefn)) {
        // Property.
        const fullPropertyName = getProperty(leftDefn);
        const propertyName = fullPropertyName.substring(fullPropertyName.indexOf('.') + 1);
        leftValue = (fullPropertyName.startsWith('category.') ?
          categoryResult[propertyName] :
          statistics[propertyName]);
      } else {
        // Scalar.
        leftValue = leftDefn;
      }

      // Identify the right value.
      let rightValue = undefined;
      const rightDefn = calculationStepDefn.right;
      if (isProperty(rightDefn)) {
        // Property.
        const fullPropertyName = getProperty(rightDefn);
        const propertyName = fullPropertyName.substring(fullPropertyName.indexOf('.') + 1);
        rightValue = (fullPropertyName.startsWith('category.') ?
          categoryResult[propertyName] :
          statistics[propertyName]);
      } else {
        rightValue = rightDefn;
      }

      // Assign the result.
      const resultFieldName = calculationStepDefn.result.substring(calculationStepDefn.result.indexOf('.') + 1);
      categoryResult[resultFieldName] = leftValue - rightValue;

    });

  } else {

    // Field-level calculation.

    // Identify the nominator.
    let leftValue = undefined;
    const leftDefn = calculationStepDefn.left;
    if (isProperty(leftDefn)) {
      const fullPropertyName = getProperty(leftDefn);
      const propertyName = fullPropertyName.substring(fullPropertyName.indexOf('.') + 1);
      leftValue = statistics[propertyName];
    } else {
      leftValue = leftDefn;
    }

    // Identify the denominator.
    let rightValue = undefined;
    const rightDefn = calculationStepDefn.right;
    if (isProperty(rightDefn)) {
      const fullPropertyName = getProperty(rightDefn);
      const propertyName = fullPropertyName.substring(fullPropertyName.indexOf('.') + 1);
      rightValue = statistics[propertyName];
    } else {
      rightValue = rightDefn;
    }

    // Assign the result.
    const resultFieldName = calculationStepDefn.result.substring(calculationStepDefn.result.indexOf('.') + 1);
    statistics[resultFieldName] = leftValue - rightValue;

  }

}


// WEBPACK FOOTER //
// ./src/app/utils/calculators/minus-calculator.js